import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import get from 'lodash/get';
import { propStyles } from '../utils/propStyles';
import DynamicLink from './DynamicLink';
import Translate from './Translate';
import { fundListFilter } from '../utils/fundListFilter';
import HTag from './HTag';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import { DataStore, EntityStore } from '../stores';
import { Header } from '../models/configuration/components/Header';
import { DynamicLinkConfig } from '../models/configuration/components/DynamicLinkConfig';
import { IQueryContext } from '@kurtosys/ksys-app-template/dist/models/query';
import { Theme } from '../models/Theme';

const FundCardHeaderWrapper = styled<any, any>(
    'div',
    'fundCardHeaderWrapper',
    'fundCardHeader'
)`
    ${propStyles};
`;

FundCardHeaderWrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingX: ['md', 'lg'],
    paddingY: ['md', 'lg'],
};

const fundCardLinkDefaultProps = {
    flex: '0 0 auto',
    color: 'white',
    bgColor: 'primary',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: ['xs', 'sm'],
    textDecoration: 'none',
    textAlign: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    borderRadius: '1em',
};

interface FundCardHeaderProps {
    theme?: Theme;
    header: Header;
    dataStore?: DataStore;
    entityStore?: EntityStore;
    queryContext: IQueryContext;
}

@inject('dataStore', 'entityStore')
@observer
class FundCardHeader extends Component<FundCardHeaderProps, any> {
    @computed
    get fundName() {
        const { nameProperty } = this.props.header;
        return get(
            this.props.entityStore?.value,
            `properties_pub.${nameProperty}.value`
        );
    }

    @computed
    get showLink() {
        const { dataStore, entityStore, header } = this.props;
        return (
            entityStore?.value &&
            fundListFilter(header, dataStore, entityStore?.value)
        );
    }

    @computed
    get fundLinkLabel() {
        const { linkLabel } = this.props.header;
        return linkLabel;
    }

    @computed
    get dynamicLinkConfig(): DynamicLinkConfig {
        const { url, linkProperty, key } = this.props.header;

        return {
            url,
            linkProperty,
            key,
        };
    }

    onClick = (link: string) => {
        const { dataStore, entityStore } = this.props;
        dataStore.logDataLayer(
            'fund_page_link',
            {
                url: link,
                entityType: entityStore?.value.type,
                clientCode: entityStore?.value.clientCode,
            },
            'click'
        );
    };

    render() {
        const { fundName, fundLinkLabel, showLink } = this;
        const { theme, entityStore } = this.props;

        return (
            <FundCardHeaderWrapper {...theme.FundCardHeader}>
                <HTag
                    componentTheme={'FundCardHeading'}
                    defaultStyleProps={{
                        color: 'body',
                        fontFamily: 'body',
                        fontWeight: 'regular',
                        fontSize: ['md', 'lg'],
                        margin: '0 1em 0 0',
                    }}
                    level={1}
                    text={fundName}
                />
                {fundLinkLabel && showLink && (
                    <DynamicLink
                        config={this.dynamicLinkConfig}
                        queryContext={entityStore?.queryContext}
                        metricContext={`fundCardHeader-${camelCase(
                            entityStore?.value.clientCode
                        )}`}
                        ariaLabelKey={'fundCardHeaderLink'}
                        onClick={this.onClick}
                        {...fundCardLinkDefaultProps}
                        {...theme.FundCardLink}
                    >
                        <Translate>{fundLinkLabel}</Translate>
                    </DynamicLink>
                )}
            </FundCardHeaderWrapper>
        );
    }
}

export default withTheme(FundCardHeader) as any;



// WEBPACK FOOTER //
// ./src/Components/FundCardHeader.tsx